import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  unsubModal: boolean;
};

const initialState: InitialState = {
  unsubModal: false,
};

const unsubModalSlice = createSlice({
  name: "unsubModalSlice",
  initialState,
  reducers: {
    toggleUnsubModal: (state, action: PayloadAction) => {
      state.unsubModal = !state.unsubModal;
      return state;
    },
  },
});

export const { toggleUnsubModal } = unsubModalSlice.actions;
export default unsubModalSlice;
